import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {},
	finalize() {
		//animation / gsap
		// planes
		let $oddPlanes = $(
			'.inner-content-wrap .coastal-text-media-block:nth-of-type(odd) .white-line svg, .inner-content-wrap .coastal-text-block:nth-of-type(odd) .white-line svg'
		)
		if ($oddPlanes.length) {
			document
				.querySelectorAll(
					'.inner-content-wrap .coastal-text-media-block:nth-of-type(odd) .white-line svg, .inner-content-wrap .coastal-text-block:nth-of-type(odd) .white-line svg'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ y: 0 },
						{
							scrollTrigger: item,
							delay: 0,
							duration: 0.5,
							y: 150,
						}
					)
				})
		}
		let $evenPlanes = $(
			'.inner-content-wrap .coastal-text-media-block:nth-of-type(even) .white-line svg, .inner-content-wrap .coastal-text-block:nth-of-type(even) .white-line svg'
		)
		if ($evenPlanes.length) {
			document
				.querySelectorAll(
					'.inner-content-wrap .coastal-text-media-block:nth-of-type(even) .white-line svg, .inner-content-wrap .coastal-text-block:nth-of-type(even) .white-line svg'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: 0 },
						{
							scrollTrigger: item,
							delay: 0,
							duration: 0.5,
							x: -150,
						}
					)
				})
		}

		//body
		let $bodyP = $('.inner-content-wrap > p, .wp-block-verse')
		if ($bodyP.length) {
			document
				.querySelectorAll('.inner-content-wrap > p, .wp-block-verse')
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ y: 20, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							y: 0,
							opacity: 1,
						}
					)
				})
		}

		//icon block
		let $iconBlock = $('.coastal-text-icon-block-wrap .coastal-text-icon-item')
		if ($iconBlock.length) {
			document
				.querySelectorAll(
					'.coastal-text-icon-block-wrap .coastal-text-icon-item'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: -20, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							x: 0,
							opacity: 1,
						}
					)
				})
		}
	},
}
